import React from 'react';
import { Link, useRouteError } from 'react-router-dom';

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render shows the fallback UI

        return { error: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service 
      
        console.log(error);
        console.log(errorInfo);
    }
    
    render() {
        if (this.state.error) {
            console.log(this.state.error.toString());
            console.log(this.state.errorInfo.componentStack);

            // You can render any custom fallback UI      
            return <h1 className="text-center">משהו השתבש</h1>;
        }

        return this.props.children;
    }
}

export const ErrorPage = () => {
    const error = useRouteError();
    const isDev = process.env.NODE_ENV === 'development';
  
    return (
        <div className='flex flex-col justify-center items-center h-screen w-screen'>
            <h1 className='text-3xl font-bold'>מצטערים!</h1>
            <p>לא ניתן לטעון את העמוד המבוקש</p>
            {isDev && error.status && <p>קוד: {error.status}</p>}
            {isDev && error.statusText && <p>{error.statusText}</p>}
            {isDev && error.message && <p>{error.message}</p>}
      </div>
    );
}

export const NotFoundPage = () => {
    return (
        <div className='flex flex-col justify-center items-center h-screen w-screen'>
            <h1 className='text-3xl font-bold'>404</h1>
            <p>העמוד אליו הגעת לא קיים</p>
            <Link to='/publisher' className='text-blue-500 underline'>חזרה לעמוד הראשי</Link>
      </div>
    );
}